var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69632 31C4.95615 31 4.32173 30.7356 3.79304 30.2069C3.26435 29.6782 3 29.0437 3 28.3035V6.98211C3 6.24079 3.26435 5.60632 3.79304 5.07871C4.32173 4.5511 4.95615 4.28674 5.69632 4.28563H19.6972V5.95528H5.69632C5.3958 5.95528 5.14982 6.05156 4.95838 6.24413C4.76583 6.43669 4.66955 6.68324 4.66955 6.98378V28.3035C4.66955 28.6029 4.76583 28.8489 4.95838 29.0415C5.15094 29.2341 5.39692 29.3304 5.69632 29.3304H27.0165C27.317 29.3304 27.563 29.2341 27.7544 29.0415C27.9481 28.8489 28.0449 28.6029 28.0449 28.3035V14.3035H29.7144V28.3035C29.7144 29.0448 29.4501 29.6793 28.9214 30.2069C28.3927 30.7356 27.7577 31 27.0165 31H5.69632ZM25.9914 11.3482V8.00894H22.6523V6.3393H25.9914V3H27.6609V6.3393H31V8.00894H27.6609V11.3482H25.9914ZM8.84342 25.1562H24.1265L19.4067 18.8617L15.0408 24.3849L12.1191 20.8535L8.84342 25.1562Z",
    fill: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.bf4308758b72a4a6be757652ecd98920.svg";
export { ForwardRef as ReactComponent };